import { Injectable, OnInit } from '@angular/core';
import { environment } from '../../environments/environment';
import { sync } from 'glob';
import { empty } from 'rxjs';
//import * as $ from "jquery";
declare var $: any;
export class CommonService implements OnInit {

    ngOnInit() {

    }
    GetKey() {
        let data: any;
        let options: any;
        data = {
            'grant_type': 'client_credentials',
            'client_id': environment.appSetting.clientid,
            'client_secret': environment.appSetting.secretkey,
            'scope': 'user/*.write'
        }
        options = {
            url: environment.appSetting.identityserver,
            type: 'POST',
            data: data,
            async: false
        };

        $.ajax(options).done(function (res) {
            environment.accessKey = res.access_token;
            environment.PracticeID = res.PracticeId;
        });

    }
    GetLoginPortalKey(username, password, type) {
        let data: any;
        let options: any;
        data = {
            'grant_type': 'password',
            'client_id': environment.appSetting.portalclientid,
            'client_secret': environment.appSetting.portalsecretkey,
            'scope': 'user/*.write',
            'UserName': username,
            'Password': password
        }
        options = {
            url: environment.appSetting.identityserver,
            type: 'POST',
            data: data,
            async: false
        };

        $.ajax(options).done(function (res) {
            environment.portalAccessKey = res.access_token;
            environment.PracticeID = res.PracticeId;
            if (type == 'login')
                environment.UserPracticeId = res.UserPracticeId;
        });

    }
    GetPortalKey(username, password) {
        let data: any;
        let options: any;
        data = {
            'grant_type': 'password',
            'client_id': environment.appSetting.portalclientid,
            'client_secret': environment.appSetting.portalsecretkey,
            'scope': 'user/*.write',
            'UserName': username,
            'Password': password
        }
        options = {
            url: environment.appSetting.identityserver,
            type: 'POST',
            data: data,
            async: false
        };

        $.ajax(options).done(function (res) {
            environment.portalAccessKey = res.access_token;
            environment.PracticeID = res.PracticeId;
            if (environment.UserPracticeId == '')
                environment.UserPracticeId = localStorage.getItem('practcode');
        });

    }
    GetAzureKey() {
        let data: any;
        let options: any;
        data = {
            'grant_type': 'client_credentials',
            'client_id': environment.appSetting.clientid,
            'client_secret': environment.appSetting.secretkey,
            'scope': 'user/*.write'
        }
        options = {
            url: environment.appSetting.azureidentityserver,
            type: 'POST',
            data: data,
            async: false
        };

        $.ajax(options).done(function (res) {
            environment.azureaccessKey = res.access_token;
            environment.PracticeID = res.PracticeId;
        });

    }
    GetAzureLoginPortalKey(username, password, type) {
        let data: any;
        let options: any;
        data = {
            'grant_type': 'password',
            'client_id': environment.appSetting.portalclientid,
            'client_secret': environment.appSetting.portalsecretkey,
            'scope': 'user/*.write',
            'UserName': username,
            'Password': password
        }
        options = {
            url: environment.appSetting.azureidentityserver,
            type: 'POST',
            data: data,
            async: false
        };

        $.ajax(options).done(function (res) {
            environment.azureportalAccessKey = res.access_token;
            environment.PracticeID = res.PracticeId;
            if (type == 'login')
                environment.UserPracticeId = res.UserPracticeId;
        });

    }
    GetAzurePortalKey(username, password) {
        let data: any;
        let options: any;
        data = {
            'grant_type': 'password',
            'client_id': environment.appSetting.portalclientid,
            'client_secret': environment.appSetting.portalsecretkey,
            'scope': 'user/*.write',
            'UserName': username,
            'Password': password
        }
        options = {
            url: environment.appSetting.azureidentityserver,
            type: 'POST',
            data: data,
            async: false
        };

        $.ajax(options).done(function (res) {
            environment.azureportalAccessKey = res.access_token;
            environment.PracticeID = res.PracticeId;
            if (environment.UserPracticeId == '')
                environment.UserPracticeId = localStorage.getItem('practcode');
        });

    }
    setDashboardDatatable(id, input) {
        $('#' + id).DataTable({
            "pagingType": "full_numbers",
            "lengthMenu": [
                [10, 25, 50, -1],
                [10, 25, 50, "All"]
            ],
            responsive: true,
            ordering: false,
            fixedHeader: {
                header: true,
                headerOffset: 45,
            },

            scrollX: true,
            language: {
                search: "_INPUT_",
                searchPlaceholder: "Search records",
                emptyTable: "No " + input.replace('-', ' ')
            }

        });

    }
    setDatatable(id, input) {
        //var table = $('#' + id).DataTable();
        //table.destroy();
        $('#' + id).DataTable({
            "pagingType": "full_numbers",
            "lengthMenu": [
                [10, 25, 50, -1],
                [10, 25, 50, "All"]
            ],
            responsive: true,
            ordering: false,
            fixedHeader: {
                header: true,
                headerOffset: 45,
            },

            scrollX: true,
            language: {
                search: "_INPUT_",
                searchPlaceholder: "Search records",
                emptyTable: "No " + input.replace('-', ' ') + "  available"
            }

        });

    }
    setDatatableTimeout(id) {
        setTimeout(function () {
            $('#' + id).DataTable({
                "pagingType": "full_numbers",
                "lengthMenu": [
                    [10, 25, 50, -1],
                    [10, 25, 50, "All"]
                ],
                responsive: true,
                ordering: false,
                fixedHeader: {
                    header: true,
                    headerOffset: 45,
                },

                scrollX: true,
                language: {
                    search: "_INPUT_",
                    searchPlaceholder: "Search records"
                }

            });
        }, 500);
    }
    appointmentDatatables(id, limit) {
        let emptyMessage = '';


        for (var i = 1; i <= limit; i++) {
            if (i == 1)
                emptyMessage = 'No appointment available';
            if (i == 2)
                emptyMessage = 'No past Appointments available';
            if (i == 3)
                emptyMessage = 'No Cancel Appointments available';
            if (i == 4)
                emptyMessage = 'No No Show Appointments available';
            var rowLength = $('#' + id + i + ' tbody tr').length;
            $('#' + id + i).DataTable({
                "pagingType": "full_numbers",
                "lengthMenu": [
                    [10, 25, 50, -1],
                    [10, 25, 50, "All"]
                ],
                responsive: true,
                ordering: false,
                fixedHeader: {
                    header: true,
                    headerOffset: 45,
                },
                scrollX: rowLength < 10 ? false : true,
                language: {
                    search: "_INPUT_",
                    searchPlaceholder: "Search records",
                    emptyTable: emptyMessage
                }

            });
        }

    }
    HL7ContextAware(context, type, code, name) {

        var URL = '';
        var CodingSystem = '';
        var TaskContext = '';
        var OrganizationID = '1.3.6.1.4.1.9328';
        switch (type) {
            case 'problem':
                CodingSystem = "2.16.840.1.113883.6.96";
                TaskContext = "PROBLISTREV";
                break;
            case 'icd':
                CodingSystem = "2.16.840.1.113883.6.103"; //ICD
                TaskContext = "PROBLISTREV";
                break;
            case 'medication':
                //CodingSystem = "2.16.840.1.113883.6.69";
                CodingSystem = "2.16.840.1.113883.6.88";
                TaskContext = "MEDOE";
                break;
            case 'lab':
                CodingSystem = "2.16.840.1.113883.6.1";
                TaskContext = "LABRREV";
                break;
            case 'drug':
                CodingSystem = "2.16.840.1.113883.6.1";
                TaskContext = "DRUG";
                break;
            default:
                return;
        }

        switch (context) {
            case 'patient':
                URL = 'http://apps2.nlm.nih.gov/medlineplus/services/mpconnect.cfm?mainSearchCriteria.v.c=' + code + '&mainSearchCriteria.v.cs=' + CodingSystem + '&mainSearchCriteria.v.dn=&informationRecipient.languageCode.c=en';
            default:
                break;
        }
        if (code == '' || code == undefined) {
            URL = 'https://vsearch.nlm.nih.gov/vivisimo/cgi-bin/query-meta?v%3aproject=medlineplus&v%3asources=medlineplus-bundle&query=' + name;
        }
        window.open(URL, '', 'width=800,height=600,scrollbars=yes');


    }
}